export enum RoleTypeEnum {
  CUSTOM = 'CUSTOM',
  ADMIN = 'ADMIN',
  DEFAULT = 'DEFAULT',
  TECHNICAL_ADMIN = 'TECHNICAL_ADMIN',
}
